export const LIST = "LIST";
export const DROPDOWN = "DROPDOWN";
export const STORE = "STORE";
export const UPDATE = "UPDATE";
export const DELETE = "DELETE";
export const UPDATE_STATUS = "UPDATE_STATUS";
export const GET_MEMBERS = "GET_MEMBERS";
export const SHOW = "SHOW";
export const EXCEL = "EXCEL";